import { Component } from '@angular/core';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-disclamers',
  templateUrl: './disclamers.component.html',
  styleUrls: ['./disclamers.component.css']
})
export class DisclamersComponent {
  
  constructor(public shared: SharedService) {
    this.shared.isWhiteMenu = true;
  }
}
